import EnvironmentColorizer from './EnvironmentColorizer';
import EnvironmentColorizerEditor from './EnvironmentColorizerEditor';
export default {
  install(molten) {
    molten.addPlugin('Model', {
      type: EnvironmentColorizer.TYPE,
      model: EnvironmentColorizer
    });
    molten.addPlugin('ModelEditor', {
      type: EnvironmentColorizer.TYPE,
      editor: EnvironmentColorizerEditor
    });
    molten.addPlugin('Colorizer', {
      type: EnvironmentColorizer.TYPE,
      name: 'Environment',
      colorizer: EnvironmentColorizer,
      objectType: 'zone'
    });
  }
};